module.exports = __webpack_public_path__ + "media/fonts/SFProText-Medium-d6e3bac0aefb3b5dc649251bec1bebfa.svg";